import { useTranslation } from 'module/hooks/use-translation';
import { Button } from '@rocketlane/ui';
import { FC } from 'react';
import styled from 'styled-components';

const Footer = styled.div`
  display: flex;
  justify-content: end;
  gap: var(--spacing-04);
  padding: var(--spacing-04) var(--spacing-05);
  border-top: 1px solid var(--scarlet-gray-10);
`;

interface Props {
  onCancel: () => void;
  onApply: () => void;
}

export const FilterPopoverFooter: FC<Props> = ({ onCancel, onApply }) => {
  return (
    <Footer>
      <Button
        variant="secondary"
        onClick={onCancel}
        data-cy="filters.popover.cancel"
      >
        {useTranslation('cancel')}
      </Button>
      <Button
        variant="primary"
        onClick={onApply}
        data-cy="filters.popover.apply"
      >
        {useTranslation('apply')}
      </Button>
    </Footer>
  );
};
